import React from 'react';
import { GridCellParams, GridColDef, GridEditInputCell } from '@mui/x-data-grid';
import { AffectingPriceFieldsType } from 'types';

export const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

// DPC Management
export const GET_DPC = 'GET_DPC';
export const DPC = 'DPC';
export const PART_TYPE = 'PART_TYPE';
export const CATEGORY_MANAGEMENT = 'CATEGORY_MANAGEMENT';

// options
export const lengthMetric = [
  {
    label: 'mm',
    value: 'MM',
  },
  {
    label: 'cm',
    value: 'CM',
  },
  {
    label: 'm',
    value: 'M',
  },
  {
    label: 'inches',
    value: 'IN',
  },
];
export const weightMetric = [
  {
    label: 'kg',
    value: 'KG',
  },
  {
    label: 'g',
    value: 'G',
  },
  {
    label: 'lbs',
    value: 'LB',
  },
];
export const monthsOptions = [
  {
    label: 'January',
    value: '1',
  },
  {
    label: 'February',
    value: '2',
  },
  {
    label: 'March',
    value: '3',
  },
  {
    label: 'April',
    value: '4',
  },
  {
    label: 'May',
    value: '5',
  },
  {
    label: 'June',
    value: '6',
  },
  {
    label: 'July',
    value: '7',
  },
  {
    label: 'August',
    value: '8',
  },
  {
    label: 'September',
    value: '9',
  },
  {
    label: 'October',
    value: '10',
  },
  {
    label: 'November',
    value: '11',
  },
  {
    label: 'December',
    value: '12',
  },
];

// Regular expressions

// Errors

export const ADD_NEW_ROW = 'ADD_NEW_ROW';

// HTTP statuses
export const UNAUTHORIZED_STATUS = 401;
export const SUCCESS_STATUS = 200;
export const RESOURCE_SUCCESSFULLY_CREATED_STATUS = 201;
export const NO_CONTENT_STATUS = 204;
export const SUCCESSFUL_HTTP_STATUSES: readonly number[] = [
  SUCCESS_STATUS,
  RESOURCE_SUCCESSFULLY_CREATED_STATUS,
  NO_CONTENT_STATUS,
];

// Styles
export enum THEMES {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
  NATURE = 'NATURE',
}

// Number format types
export const CURRENCY_FORMAT = 'currency';
export const DECIMAL_FORMAT = 'decimal';
export const PERCENT_FORMAT = 'percent';
export const UNIT_FORMAT = 'unit';

// Currencies
export const NEW_ZEALAND_CURRENCY = 'NZD';
export const AUSTRALIAN_CURRENCY = 'AUD';

// Country Codes
export const NEW_ZEALAND_COUNTRY_CODE = 'NZ';
export const AUSTRALIAN_COUNTRY_CODE = 'AU';

// Locations
export const NEW_ZEALAND_LOCATION = 'New Zealand';

// Local Storage keys
export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'accessToken';
export const AUTH_USER_LOCAL_STORAGE_KEY = 'authUser';

// React Query keys
export const INVOICE_LIST = 'invoiceList';
export const SINGLE_INVOICE = 'singleInvoice';
export const SEARCH_CONTACT_LIST = 'searchContactList';
export const SEARCH_USER_LIST = 'searchUserList';
export const EMAIL_XERO_INVOICE = 'emailXeroInvoice';
export const CONTACT_DETAILS = 'contact';
export const USER_DETAILS = 'user';
export const EDIT_CREDIT_NOTE = 'editCreditNote';
export const TOTAL_SALES_COUNT = 'totalSalesCount';
export const TOTAL_METRICS_COUNT = 'totalMetricsCount';
export const TODAYS_SALES_LIST = 'todaysSalesList';
export const DAILY_METRICS = 'dailyMetrics';
export const TOTAL_SALES_METRICS = 'totalSalesMetrics';
export const TOTAL_SALES_PERSON_SALES_LIST = 'totalSalesPersonSalesList';
export const TOTAL_SALES_LIST = 'totalSalesList';
export const PARTS_TRADER_LIST = 'partsTraderList';
export const SINGLE_PARTS_TRADER = 'singlePartsTrader';
export const CREDIT_NOTE_LIST = 'creditNoteList';
export const PAYMENTS_LIST = 'paymentsList';
export const WORK_ORDER_LIST = 'workOrderList';
export const SINGLE_WORK_ORDER = 'singleWorkOrder';
export const TRADEME_CATEGORY = 'tradeMeCategory';
export const SINGLE_PART = 'singlePart';
export const SEARCH_PART_VEHICLE = 'searchPartVehicle';
export const SIMILAR_PART_LOOKUP = 'similarPartLookup';
export const SIMILAR_SALES_LOOKUP = 'similarSalesLookup';
export const SIMILAR_VEHICLE_LOOKUP = 'similarVehicleLookup';
export const SINGLE_VEHICLE = 'singleVehicle';
export const WEB_SHOP_DATA = 'webShopData';
export const TRADE_ME_DATA = 'tradeMeData';
export const LOCATIONS_LIST = 'locationsList';
export const TENANT_DATA = 'tenantData';
export const TENANT_LOGO = 'tenantLogo';
export const VEHICLE_LOOKUP = 'vehicleLookup';
export const VEHICLE_TOTAL_SALES = 'vehicleTotalSales';
export const HISTORY = 'history';
export const QUICK_SALE_VIEW = 'quickSaleView';
export const ACCOUNTS_LIST = 'accountsList';
export const FILTER_FIELD_VALUES = 'filterFieldValues';
export const FILTER_YEAR_VALUES = 'filterYearValues';
export const FILTER_MAKE_VALUES = 'filterMakeValues';
export const FILTER_MODEL_VALUES = 'filterModelValues';
export const FILTER_SUB_MODEL_VALUES = 'filterSubModelValues';
export const FILTER_PART_TYPE_VALUES = 'filterPartTypeValues';
export const FILTER_INTERCHANGE_PART_VALUES = 'filterInterchangePartValues';
export const ALL_TENANT = 'getAllTenants';
export const TENANT = 'getTenantById';

// Statuses
export const ERROR_STATUS_MESSAGE = 'error';
export const SUCCESS_STATUS_MESSAGE = 'success';
export const WARNING_STATUS_MESSAGE = 'warning';

// CSS
export const FLEX_START = 'flex-start';
export const SPACE_BETWEEN = 'space-between';

// Class names, ids
export const IS_VIEW_MODE_TABLE_CLASS_NAME = 'is-view-mode-table';
export const STICKY_ACTIONS_CELL_CLASS_NAME = 'actions-cell';
export const STICKY_ACTIONS_HEADER_CELL_CLASS_NAME = 'actions-header-cell';
export const REMOVE_ROW_CELL_CLASS_NAME = 'remove-row-button';
export const SUBMIT_INPUT_BY_ID = 'submit-input-by-id';

// MUI Properties
export const COLOR_PROPERTY = 'color';
export const positiveInteger: Partial<GridColDef> = {
  editable: true,
  type: 'number',
  renderEditCell: (params: GridCellParams) => {
    return (
      <GridEditInputCell
        {...params}
        inputProps={{
          min: 0,
        }}
      />
    );
  },
  valueParser: (value) => {
    return +value < 0 ? 0 : value;
  },
  valueFormatter: (params) => {
    const parsedValue = parseFloat(params.value);

    return !isNaN(parsedValue) ? parsedValue.toFixed(2) : '';
  },
};

// Common Actions
export const PRINT = 'print';
export const EMAIL = 'email';
export const DELETE = 'delete';
export const EDIT = 'edit';
export const ADD = 'add';
export const APPROVE = 'approve';
export const DISPATCH = 'dispatch';
export const REFETCH = 'refecth';

// Sort models
export const ASC = 'asc';
export const DESC = 'desc';

// Data Grid Actions
export const HIDDEN = 'hidden';
export const VIEW = 'view';
export const PREVIEW = 'preview';
export const NEW_TAB = 'new-tab';

// Tax Types
export const INCLUSIVE = 'Inclusive';
export const EXCLUSIVE = 'Exclusive';
export const UNIT_PRICE = 'unit_price';
export const QUANTITY = 'quantity';
export const TAX_RATE = 'tax_type';
export const LINE_AMOUNT = 'line_amount';
export const TAX_INCLUSIVE = 'INCLUSIVE';
export const TAX_EXCLUSIVE = 'EXCLUSIVE';
export const NO_TAX = 'NO_TAX';
export const affectingPriceFields: readonly AffectingPriceFieldsType[] = [UNIT_PRICE, QUANTITY, TAX_RATE, LINE_AMOUNT];
export const taxActions = [
  {
    label: 'Tax Exclusive',
    value: TAX_EXCLUSIVE,
  },
  {
    label: 'Tax Inclusive',
    value: TAX_INCLUSIVE,
  },
  {
    label: 'No Tax',
    value: NO_TAX,
  },
];
export const NEW_ZEALAND_TAX_RATE = 0.15;
export const AUSTRALIAN_TAX_RATE = 0.1;

// Parts View Types
export const VIEW_LIST_VIEW_TYPE = 'list-view';
export const VIEW_CARD_VIEW_TYPE = 'card-view';
export const VIEW_TABLE_VIEW_TYPE = 'table-view';

// Misc
export const ADD_PARTS_BY_TAG_NUMBER = 'addPartsByTagNumber';
export const ADD_PARTS_BY_STOCK_NUMBER = 'addPartsByStockNumber';
export const ADD_NON_STOCK_PARTS = 'addNonStockParts';

export const LABOR = 'LABOR';

export const SOLD_STATUS = 'SOLD';
export const NOT_SOLD_STATUS = 'NOT_SOLD';

export const YEAR_LIST = Array.from(Array(Number(new Date().getFullYear()) + 1 - 1944), (_, i) => ({
  value: i + +1945,
  label: (i + 1945).toString(),
})).reverse();

export const LABOUR_SERVICE = 'Labour';
export const SUCCESS_FEE_SERVICE = 'Success fee';
export const OTHER_ITEM_SERVICE = 'Other Item';
export const SHIPPING_SERVICE = 'Shipping';

export const serviceItems: readonly string[] = [
  LABOUR_SERVICE,
  SUCCESS_FEE_SERVICE,
  OTHER_ITEM_SERVICE,
  SHIPPING_SERVICE,
];

export const UPLOAD_TO_WEB_SHOP = 'Upload To Web Shop';
export const UPLOAD_TO_TRADEME = 'Upload To TradeMe';
export const EDIT_WEB_SHOP = 'Edit Web Shop';

// Paper sizes (on 72 DPI)
export const A4_PAPER_WIDTH = 595;
export const A4_PAPER_HEIGHT = 842;

export const VIN_CODE_LENGTH = 17;

export const salesChannels = {
  'Walk In': 'Walk In',
  Phone: 'Phone',
  Email: 'Email',
  PartsTrader: 'PartsTrader',
  TradeMe: 'TradeMe',
  'Facebook Marketplace': 'Facebook Marketplace',
  Capricorn: 'Capricorn',
  'Web Shop': 'Web Shop',
  WhatsApp: 'WhatsApp',
  Ebay: 'Ebay',
  Export: 'Export',
  Other: 'Other',
};

export const countries = [
  { label: 'Afghanistan', value: 'AF' },
  { label: 'Aland Islands', value: 'AX' },
  { label: 'Albania', value: 'AL' },
  { label: 'Algeria', value: 'DZ' },
  { label: 'American Samoa', value: 'AS' },
  { label: 'Andorra', value: 'AD' },
  { label: 'Angola', value: 'AO' },
  { label: 'Anguilla', value: 'AI' },
  { label: 'Antarctica', value: 'AQ' },
  { label: 'Antigua and Barbuda', value: 'AG' },
  { label: 'Argentina', value: 'AR' },
  { label: 'Armenia', value: 'AM' },
  { label: 'Aruba', value: 'AW' },
  { label: 'Australia', value: 'AUS' },
  { label: 'Austria', value: 'AT' },
  { label: 'Azerbaijan', value: 'AZ' },
  { label: 'The Bahamas', value: 'BS' },
  { label: 'Bahrain', value: 'BH' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Belarus', value: 'BY' },
  { label: 'Belgium', value: 'BE' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Benin', value: 'BJ' },
  { label: 'Bermuda', value: 'BM' },
  { label: 'Bhutan', value: 'BT' },
  { label: 'Bolivia', value: 'BO' },
  { label: 'Bonaire, Sint Eustatius and Saba', value: 'BQ' },
  { label: 'Bosnia and Herzegovina', value: 'BA' },
  { label: 'Botswana', value: 'BW' },
  { label: 'Bouvet Island', value: 'BV' },
  { label: 'Brazil', value: 'BR' },
  { label: 'British Indian Ocean Territory', value: 'IO' },
  { label: 'Brunei', value: 'BN' },
  { label: 'Bulgaria', value: 'BG' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Cambodia', value: 'KH' },
  { label: 'Cameroon', value: 'CM' },
  { label: 'Canada', value: 'CA' },
  { label: 'Cape Verde', value: 'CV' },
  { label: 'Cayman Islands', value: 'KY' },
  { label: 'Central African Republic', value: 'CF' },
  { label: 'Chad', value: 'TD' },
  { label: 'Chile', value: 'CL' },
  { label: 'China', value: 'CN' },
  { label: 'Christmas Island', value: 'CX' },
  { label: 'Cocos (Keeling) Islands', value: 'CC' },
  { label: 'Colombia', value: 'CO' },
  { label: 'Comoros', value: 'KM' },
  { label: 'Congo', value: 'CG' },
  { label: 'Cook Islands', value: 'CK' },
  { label: 'Costa Rica', value: 'CR' },
  { label: 'Cote D‘Ivoire (Ivory Coast)', value: 'CI' },
  { label: 'Croatia', value: 'HR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Curaçao', value: 'CW' },
  { label: 'Cyprus', value: 'CY' },
  { label: 'Czech Republic', value: 'CZ' },
  { label: 'Democratic Republic of The Congo', value: 'CD' },
  { label: 'Denmark', value: 'DK' },
  { label: 'Djibouti', value: 'DJ' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Dominican Republic', value: 'DO' },
  { label: 'East Timor', value: 'TL' },
  { label: 'Ecuador', value: 'EC' },
  { label: 'Egypt', value: 'EG' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Equatorial Guinea', value: 'GQ' },
  { label: 'Eritrea', value: 'ER' },
  { label: 'Estonia', value: 'EE' },
  { label: 'Ethiopia', value: 'ET' },
  { label: 'Falkland Islands', value: 'FK' },
  { label: 'Faroe Islands', value: 'FO' },
  { label: 'Fiji Islands', value: 'FJ' },
  { label: 'Finland', value: 'FI' },
  { label: 'France', value: 'FR' },
  { label: 'French Guiana', value: 'GF' },
  { label: 'French Polynesia', value: 'PF' },
  { label: 'French Southern Territories', value: 'TF' },
  { label: 'Gabon', value: 'GA' },
  { label: 'Gambia', value: 'GM' },
  { label: 'Georgia', value: 'GE' },
  { label: 'Germany', value: 'DE' },
  { label: 'Ghana', value: 'GH' },
  { label: 'Gibraltar', value: 'GI' },
  { label: 'Greece', value: 'GR' },
  { label: 'Greenland', value: 'GL' },
  { label: 'Grenada', value: 'GD' },
  { label: 'Guadeloupe', value: 'GP' },
  { label: 'Guam', value: 'GU' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guernsey and Alderney', value: 'GG' },
  { label: 'Guinea', value: 'GN' },
  { label: 'Guinea-Bissau', value: 'GW' },
  { label: 'Guyana', value: 'GY' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Heard Island and Mcdonald Islands', value: 'HM' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Hong Kong', value: 'HK' },
  { label: 'Hungary', value: 'HU' },
  { label: 'Iceland', value: 'IS' },
  { label: 'India', value: 'IN' },
  { label: 'Indonesia', value: 'ID' },
  { label: 'Iran', value: 'IR' },
  { label: 'Iraq', value: 'IQ' },
  { label: 'Ireland', value: 'IE' },
  { label: 'Israel', value: 'IL' },
  { label: 'Italy', value: 'IT' },
  { label: 'Jamaica', value: 'JM' },
  { label: 'Japan', value: 'JP' },
  { label: 'Jersey', value: 'JE' },
  { label: 'Jordan', value: 'JO' },
  { label: 'Kazakhstan', value: 'KZ' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Kiribati', value: 'KI' },
  { label: 'Kosovo', value: 'XK' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Kyrgyzstan', value: 'KG' },
  { label: 'Laos', value: 'LA' },
  { label: 'Latvia', value: 'LV' },
  { label: 'Lebanon', value: 'LB' },
  { label: 'Lesotho', value: 'LS' },
  { label: 'Liberia', value: 'LR' },
  { label: 'Libya', value: 'LY' },
  { label: 'Liechtenstein', value: 'LI' },
  { label: 'Lithuania', value: 'LT' },
  { label: 'Luxembourg', value: 'LU' },
  { label: 'Macau S.A.R.', value: 'MO' },
  { label: 'Macedonia', value: 'MK' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Malawi', value: 'MW' },
  { label: 'Malaysia', value: 'MY' },
  { label: 'Maldives', value: 'MV' },
  { label: 'Mali', value: 'ML' },
  { label: 'Malta', value: 'MT' },
  { label: 'Isle of Man', value: 'IM' },
  { label: 'Marshall Islands', value: 'MH' },
  { label: 'Martinique', value: 'MQ' },
  { label: 'Mauritania', value: 'MR' },
  { label: 'Mauritius', value: 'MU' },
  { label: 'Mayotte', value: 'YT' },
  { label: 'Mexico', value: 'MX' },
  { label: 'Micronesia', value: 'FM' },
  { label: 'Moldova', value: 'MD' },
  { label: 'Monaco', value: 'MC' },
  { label: 'Mongolia', value: 'MN' },
  { label: 'Montenegro', value: 'ME' },
  { label: 'Montserrat', value: 'MS' },
  { label: 'Morocco', value: 'MA' },
  { label: 'Mozambique', value: 'MZ' },
  { label: 'Myanmar', value: 'MM' },
  { label: 'Namibia', value: 'NA' },
  { label: 'Nauru', value: 'NR' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'New Caledonia', value: 'NC' },
  { label: 'New Zealand', value: 'NZ' },
  { label: 'Nicaragua', value: 'NI' },
  { label: 'Niger', value: 'NE' },
  { label: 'Nigeria', value: 'NG' },
  { label: 'Niue', value: 'NU' },
  { label: 'Norfolk Island', value: 'NF' },
  { label: 'North Korea', value: 'KP' },
  { label: 'Northern Mariana Islands', value: 'MP' },
  { label: 'Norway', value: 'NO' },
  { label: 'Not Known', value: 'XX' },
  { label: 'Oman', value: 'OM' },
  { label: 'Other', value: 'ZZ' },
  { label: 'Pakistan', value: 'PK' },
  { label: 'Palau', value: 'PW' },
  { label: 'Palestinian Territory Occupied', value: 'PS' },
  { label: 'Panama', value: 'PA' },
  { label: 'Papua New Guinea', value: 'PG' },
  { label: 'Paraguay', value: 'PY' },
  { label: 'Peru', value: 'PE' },
  { label: 'Philippines', value: 'PH' },
  { label: 'Pitcairn Island', value: 'PN' },
  { label: 'Poland', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Puerto Rico', value: 'PR' },
  { label: 'Qatar', value: 'QA' },
  { label: 'Reunion', value: 'RE' },
  { label: 'Romania', value: 'RO' },
  { label: 'Rwanda', value: 'RW' },
  { label: 'Saint Helena', value: 'SH' },
  { label: 'Saint Kitts and Nevis', value: 'KN' },
  { label: 'Saint Lucia', value: 'LC' },
  { label: 'Saint Pierre and Miquelon', value: 'PM' },
  { label: 'Saint Vincent and The Grenadines', value: 'VC' },
  { label: 'Saint-Barthelemy', value: 'BL' },
  { label: 'Saint-Martin (French Part)', value: 'MF' },
  { label: 'Samoa', value: 'WS' },
  { label: 'San Marino', value: 'SM' },
  { label: 'Sao Tome and Principe', value: 'ST' },
  { label: 'Saudi Arabia', value: 'SA' },
  { label: 'Senegal', value: 'SN' },
  { label: 'Serbia', value: 'RS' },
  { label: 'Seychelles', value: 'SC' },
  { label: 'Sierra Leone', value: 'SL' },
  { label: 'Singapore', value: 'SG' },
  { label: 'Saint Maarten (Dutch Part)', value: 'SX' },
  { label: 'Slovakia', value: 'SK' },
  { label: 'Slovenia', value: 'SI' },
  { label: 'Solomon Islands', value: 'SB' },
  { label: 'Somalia', value: 'SO' },
  { label: 'South Africa', value: 'ZA' },
  { label: 'South Georgia', value: 'GS' },
  { label: 'South Korea', value: 'KR' },
  { label: 'South Sudan', value: 'SS' },
  { label: 'Spain', value: 'ES' },
  { label: 'Sri Lanka', value: 'LK' },
  { label: 'Sudan', value: 'SD' },
  { label: 'Suriname', value: 'SR' },
  { label: 'Svalbard and Jan Mayen Islands', value: 'SJ' },
  { label: 'Swaziland', value: 'SZ' },
  { label: 'Sweden', value: 'SE' },
  { label: 'Switzerland', value: 'CH' },
  { label: 'Syria', value: 'SY' },
  { label: 'Taiwan', value: 'TW' },
  { label: 'Tajikistan', value: 'TJ' },
  { label: 'Tanzania', value: 'TZ' },
  { label: 'Thailand', value: 'TH' },
  { label: 'Togo', value: 'TG' },
  { label: 'Tokelau', value: 'TK' },
  { label: 'Tonga', value: 'TO' },
  { label: 'Trinidad and Tobago', value: 'TT' },
  { label: 'Tunisia', value: 'TN' },
  { label: 'Turkey', value: 'TR' },
  { label: 'Turkmenistan', value: 'TM' },
  { label: 'Turks and Caicos Islands', value: 'TC' },
  { label: 'Tuvalu', value: 'TV' },
  { label: 'Uganda', value: 'UG' },
  { label: 'Ukraine', value: 'UA' },
  { label: 'United Arab Emirates', value: 'AE' },
  { label: 'United Kingdom', value: 'GB' },
  { label: 'United States Minor Outlying Islands', value: 'UM' },
  { label: 'Uruguay', value: 'UY' },
  { label: 'USA', value: 'US' },
  { label: 'Russia', value: 'RU' },
  { label: 'Uzbekistan', value: 'UZ' },
  { label: 'Vanuatu', value: 'VU' },
  { label: 'Vatican City State', value: 'VA' },
  { label: 'Venezuela', value: 'VE' },
  { label: 'Vietnam', value: 'VN' },
  { label: 'Virgin Islands (British)', value: 'VG' },
  { label: 'Virgin Islands (US)', value: 'VI' },
  { label: 'Wallis and Futuna Islands', value: 'WF' },
  { label: 'Western Sahara', value: 'EH' },
  { label: 'Yemen', value: 'YE' },
  { label: 'Yugoslavia', value: 'YU' },
  { label: 'Zambia', value: 'ZM' },
  { label: 'Zimbabwe', value: 'ZW' },
];

const YEAR_OPTIONS_START_YEAR = 1920;
const YEAR_OPTIONS_CURRENT_YEAR = new Date().getFullYear();

export const yearOptions = Array.from(
  { length: YEAR_OPTIONS_CURRENT_YEAR - YEAR_OPTIONS_START_YEAR + 1 },
  (_, index) => {
    const year = String(YEAR_OPTIONS_CURRENT_YEAR - index);

    return {
      label: year,
      value: year,
    };
  },
);
